import { FORM } from "../../Constants/Endpoinst";
import { ApiRequestInterceptor } from "../apiRequest";

export const fetchGetForms = async () => {
  const method = "GET";

  // 🔑 saca token del localStorage (como en login)
  const stored = JSON.parse(localStorage.getItem("logindata") || "{}");
  const token = stored?.data?.token || "";

  if (!token) {
    throw new Error("No hay token. Inicia sesión.");
  }

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const response = await ApiRequestInterceptor(FORM.getForms, method, null, headers);

  if (response.code === 200) {
    return response; // { items, count, ... }
  } else {
    const errorMessage = response?.data?.error || "Error desconocido";
    throw new Error(errorMessage);
  }
};